<template>
  <a-form
    class="mod-form mod-step2"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item label="找回方式" >
      <a-select size="large" v-model="type" :options="options">
      </a-select>
      <span slot="help" v-if="!options.length">您未预留有效的手机号、邮箱、安全问题！如需要找回密码，请通过实名认证重新设置密码。</span>
    </a-form-item>
    <a-form-item label="手机号码" v-if="type === 'mobile'">
      <a-input
        size="large"
        v-model="phone"
        readonly
      >
        <span slot="addonBefore">{{ areaCodeText }}</span>
      </a-input>
    </a-form-item>
    <a-form-item label="邮箱" v-if="type === 'email'">
      <a-input
        size="large"
        v-model="email"
        readonly
      >
      </a-input>
    </a-form-item>
    <a-form-item label="密保问题" v-if="type === 'question'">
      <a-select size="large" v-model="question" :options="questions" placeholder="请选择密保问题">
      </a-select>
    </a-form-item>
    <a-form-item label="密保答案" v-if="type === 'question'">
      <a-input
        size="large"
        v-model.trim="answer"
        placeholder="请输入密保答案"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item label="手机验证码" v-if="type === 'mobile'">
      <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="3" :areaCode="areaCode" :value="phone" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item label="邮箱验证码" v-if="type === 'email'">
      <user-verification-code placeholder="请输入邮箱动态码" size="large" type="email" actionText="获取邮箱动态码" :smsType="3" :value="email" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" html-type="submit">下一步</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { find } from 'lodash'
import { forgetPasswordCodeVerify, forgetPasswordQuestionVerify } from '@/api/login'
import areaCodeOptions from '@/utils/areacode'
import eventBus from '../../../components/eventBus.js'

export default {
  props: {
    phone: String,
    areaCode: String,
    email: String,
    questions: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      options: [],
      type: '',
      token: '',
      finalToken: '',
      code: '',
      question: '',
      answer: '',
      loading: false,
      errCode: ''
    }
  },
  computed: {
    areaCodeText () {
      const value = find(areaCodeOptions, { value: this.areaCode })

      return value ? value.title : '中国+86'
    }
  },
  created () {
    const { phone, email, questions } = this
    const options = []

    if (questions && questions.length) {
      options.push({
        label: '密保问题',
        value: 'question'
      })
      this.type = 'question'
      this.question = questions[0].value
    }

    if (email) {
      options.push({
        label: '注册邮箱',
        value: 'email'
      })
      this.type = 'email'
    }

    if (phone) {
      options.push({
        label: '注册手机',
        value: 'mobile'
      })
      this.type = 'mobile'
    }

    this.options = options

    const self = this
    eventBus.$on('get-token', (value) => {
      self.onGetFinalToken(value)
    })
  },
  methods: {
    onChange (value) {
      this.type = value
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const { token, finalToken, code, phone, email, question, answer, type } = this
          let params = {}
          let method = forgetPasswordCodeVerify

          if (type === 'question') {
            if (!answer) {
              this.$error({
                content: '请输入密保答案！',
                centered: true
              })
              return
            }
            params = {
              questionId: question,
              answer,
              sliderCaptcha: token
            }
            method = forgetPasswordQuestionVerify
          } else {
            if (!code) {
              this.$error({
                content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
                centered: true
              })
              return
            }
            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true
              })
              return
            }
            if (!finalToken) {
              this.$error({
                content: '请点击获取动态码！',
                centered: true
              })
              return
            }
            params = {
              verifyType: type === 'mobile' ? 0 : 1,
              valueInfo: type === 'mobile' ? phone : email,
              verifyCode: code
            }
          }

          try {
            this.loading = true
            const data = await method(params)
            this.$emit('next', data.token)
          } catch (err) {
            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
            if (err.code.toString().includes(1000)) {
              this.errCode = err.code
            }
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    }
  }
}
</script>
